import { useAuth0 } from "@auth0/auth0-react";
import { useResetRecoilState } from "recoil";

import { Button } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";

import Loading from "./Loading";
import ConstList from "../utils/ConstList";
import { LoginUserAtom } from "../stores/LoginUserAtom";

function LoginButton() {
  const {
    isAuthenticated,
    loginWithRedirect,
    logout,
    isLoading,
  } = useAuth0();

  const resetLoginUser = useResetRecoilState(
    LoginUserAtom
  );

  const handleLogin = () => {
    loginWithRedirect({
      redirect_uri: ConstList.REDIRECT_URL,
      audience:
        "https://m-and-t.jp.auth0.com/api/v2/",
      connection: ConstList.DATABASE_NAME,
    });
  };

  const handleLogout = () => {
    /*
     * React側に保持しているユーザー情報を先に削除する。
     */
    resetLoginUser();

    /*
     * このプロジェクトのAuth0 SDKは旧形式なので、
     * logoutParamsではなくreturnToを直接指定する。
     */
    logout({
      returnTo: "http://localhost:3000/sales_management/login",
    });
  };

  if (isLoading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return (
      <Button
        type="button"
        onClick={handleLogout}
        variant="outlined"
        endIcon={<LogoutIcon />}
      >
        ログアウト
      </Button>
    );
  }

  return (
    <Button
      type="button"
      onClick={handleLogin}
      variant="contained"
      endIcon={
        <LoginIcon sx={{ color: "inherit" }} />
      }
      sx={{
        bgcolor: "primary.main",
        color: 'common.white',
        "&:hover": {
          bgcolor: "primary.dark",
        },
      }}
    >
      ログイン
    </Button>
  );
}

export default LoginButton;
